import { z } from 'zod';

import { TaskPreviewSchema } from '@/task-manager/entities/task-preview';

export const AlertTaskSchema = TaskPreviewSchema.pick({
  id: true,
  title: true,
  subtitle: true,
  status: true,
  priority: true,
});

export type AlertTask = z.infer<typeof AlertTaskSchema>;
